import { render, staticRenderFns } from "./payStatus.vue?vue&type=template&id=6f3342bb&"
import script from "./payStatus.vue?vue&type=script&lang=js&"
export * from "./payStatus.vue?vue&type=script&lang=js&"
import style0 from "./payStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports